<sham-status-layout
  [imageSrc]="'assets/images/Done.png'"
  [title]="'auth.registerSuccess.title' | translate"
  [description]="'auth.registerSuccess.description' | translate"
  [primaryBtnLabel]="'auth.registerSuccess.goToHomePage' | translate"
  (primaryAction)="navigateToHome()"
>
</sham-status-layout>
